function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 50,
  fill: "#5AE6D9"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 12,
  width: 68,
  height: 18,
  rx: 3,
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 15C16 13.3431 17.3431 12 19 12H34V30H19C17.3431 30 16 28.6569 16 27V15Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 21,
  r: 4,
  fill: "#5AE6D9"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 39,
  y: 20,
  width: 40,
  height: 2,
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 41,
  width: 68,
  height: 18,
  rx: 3,
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16 44C16 42.3431 17.3431 41 19 41H34V59H19C17.3431 59 16 57.6569 16 56V44Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 50,
  r: 4,
  fill: "#5AE6D9"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 39,
  y: 49,
  width: 40,
  height: 2,
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 70,
  width: 68,
  height: 18,
  rx: 3,
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M16 73C16 71.3431 17.3431 70 19 70H34V88H19C17.3431 88 16 86.6569 16 85V73Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 79,
  r: 4,
  fill: "#5AE6D9"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 39,
  y: 78,
  width: 40,
  height: 2,
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 65.2046,
  y: 69.4472,
  width: 6,
  height: 10,
  transform: "rotate(-45 65.2046 69.4472)",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 50.3553,
  cy: 50.3553,
  r: 24,
  transform: "rotate(-45 50.3553 50.3553)",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 50.3553,
  cy: 50.3553,
  r: 18,
  transform: "rotate(-45 50.3553 50.3553)",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2548 40.4559C54.7875 34.9885 45.9232 34.9885 40.4558 40.4559",
  stroke: "black",
  strokeWidth: 2
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 68.033,
  y: 77.9325,
  width: 14,
  height: 34,
  rx: 7,
  transform: "rotate(-45 68.033 77.9325)",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 77.9325,
  y: 86.4178,
  width: 12,
  height: 10,
  transform: "rotate(-45 77.9325 86.4178)",
  fill: "black"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 86.4178,
  y: 94.9031,
  width: 12,
  height: 2,
  transform: "rotate(-45 86.4178 94.9031)",
  fill: "black"
});

var SvgNotFound = function SvgNotFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not_found.51f95f25.svg";
export { ForwardRef as ReactComponent };